import "./LandingPage.css";
import { useEffect, useRef, useState } from "react";
import {useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import UserProfile from "../Context/UserProfile";
import MessageDisplay from "../CommonPages/MessageDisplay";
import { loginRequest} from "../Services/ContrectBackendAPI";



const LoginPage = ({ setDisplayLogin })=>{
	const usrForm = useRef(null);
	const navigate = useNavigate();
	const [msg, setMsg] = useState("");
	const [msgType, setMsgType] = useState("");
	useEffect(() => {
		if (UserProfile.getLoginStatus() === "1") {
			navigate("/Home");
		}
	}, []);
	const handleSendOTP = (e) => {
		e.preventDefault();
		if (!validateForm()) {
			return;
		}
		var postBody = {
			ContactInfo: usrForm.current['phonePrefix'].value +usrForm.current['userPhone'].value
		};
		console.log(postBody);
		loginRequest(postBody).then(r => r.json()).then(res => {
			console.log(res);
			if (res.status !== 1)
			{
				setMsg("Not able to send OTP. Please try again later.");
				setMsgType("Error");
				return;
			}
			if (res.userId===0) {
				setMsg("Not able to send OTP. Please try again later.");
				setMsgType("Error");
				return;
			}
			UserProfile.setUserId(res.userId);
			UserProfile.setLoginStatus("0");
			setDisplayLogin(3);
		}).catch(err => {
			console.log(err);
		});
	};
	const validateForm = () =>
	{
		var Contact = "";
		Contact = usrForm.current['phonePrefix'].value + usrForm.current['userPhone'].value;
		var phoneRegex = /^\+91[6-9]\d{9}$/;
		if (!phoneRegex.test(Contact)) {
			setMsg("Contact info is not valid. It has to be a phone number.");
				setMsgType("Error");
				return false;
		}
		return true;
	}

	return (
		<>
			<MessageDisplay msgType={msgType} msg={msg} setMsg={setMsg} />
			<div className="login-container">

				<div className="login-header">
					<div className="logo">
						<a style={{ textDecoration: "none" }} href="/">
							<span style={{ color: 'white' }}>Contr
								<span style={{ color: "#ff8400" }}>e</span>
								ct</span>
						</a>
					</div>
					<h1>Welcome back</h1>
					<p>Sign in to access your contracts and agreements</p>
				</div>
				<div className="login-form">

					<Form ref={usrForm} onSubmit={handleSendOTP} >


						<div className="form-content login-tab-content" style={{textAlign:"left"}} id="phone-form" >
							<div className="form-group">
								<label for="phone">Phone number</label>
								<div className="phone-input">
									<select className="phone-prefix form-control" style={{ width:"20%" }} name="phonePrefix">
										<option value="+1" >+1</option>
										<option value="+44">+44</option>
										<option value="+91" selected={true}>+91</option>
										<option value="+61">+61</option>
									</select>
									<input type="tel" name="userPhone" className="form-control phone-number" placeholder="123-456-7890" />
								</div>
							</div>
							<div className="row">
								<div className="col-6" style={{textAlign:"right"}}>
									<button type="button" className="btn btn-secondary" onClick={(e)=>{
										e.preventDefault();
										navigate("/");
									}}>Back</button>
								</div>
								<div className="col-6">
									<button type="submit" className="btn btn-primary">Send OTP</button>
								</div>
							</div>
						</div>
					</Form>
				</div>
			</div>
			
		</>
	);
};
export default LoginPage;